module.exports = __webpack_public_path__ + "media/images/new_landing/case/johany-hero-0672969f5ec23cfb881b6a2480bc95be.jpg";